import { ArticleAuthor } from './article-author';
import { Category } from './category';

export enum ArticleTheme {
    Light = 'light',
    Dark = 'dark',
}

export type Article = {
    id?: string | undefined;
    title: string;
    description: string;
    summary?: string;
    backgroundColor?: string;
    leadImage?: string;
    leadPortraitImage?: string;
    categories: Category[];
    author?: ArticleAuthor;
    builderModel: any;
    readMoreUrl?: string;
    url?: string;
    keywords?: string;

    tag?: string;
    priority?: number;

    lastUpdated?: number | null;
    createdDate?: number | null;
    firstPublished?: number | null;

    seoTitle: string;
    seoDescription: string;

    readingTime?: number;
    theme?: ArticleTheme;

    schemas?: {
        type: string;
        value: string;
    }[];
};
